export default {
  onboarding: {
    welcome: {
      title: "Bienvenue sur",
      subtitle: "Votre app de recherche de paris sportifs pour les props, les combinés et les grandes tendances. Il est temps de passer au niveau supérieur.",
      headline: "Trouvez votre prochain pari",
      secondaryCta: "Vous avez déjà un compte? Connectez-vous",
    },
    leagues: {
      title: "Choisissez vos ligues favorites",
      subtitle: "Voyez d'abord les ligues qui vous intéressent, chaque fois que vous ouvrez l'app.",
    },
    location: {
      title: "Voyez ce qui est disponible près de vous",
      subtitle: "Activez la localisation pour voir les opérateurs et les offres disponibles dans votre région.",
      allowLocationSharing: "Autoriser le partage de localisation",
      orSelectRegion: "ou sélectionner votre région",
    },
    providers: {
      title: "Choisissez vos opérateurs",
      subtitle: "Choisissez vos opérateurs pour des tendances, des cotes et une expérience de betslip personnalisées.",
      emptyCta: "Je n'en ai pas encore",
    },
    odds: {
      title: "Choisissez votre format de cotes",
      subtitle: "Affichez les cotes dans le format qui vous convient le mieux pour décider plus vite et plus facilement.",
    },
    socialProof: {
      title: "Adopté par les parieurs partout",
      subtitle: "Des nouveaux utilisateurs aux parieurs quotidiens, Linemate fournit des analyses plus intelligentes à grande échelle",
      reviewer: "Avis de l'App Store",
      reviews: {
        review1: {
          title: "Vraiment l'app la mieux conçue que j'ai vue depuis longtemps.",
          text: "Tout est exactement à sa place, chaque sélection fonctionne comme prévu, une app très minutieusement conçue, riche en informations, mais très efficace et organisée. En tant que passionné de stats, bravo à Linemate pour la conception de l'app et la facilité à trouver les bons choix."
        },
        review2: {
          title: "La meilleure app de toutes",
          text: "C'est à 100% la meilleure app pour les paris sportifs... après quelques jours d'essai, j'étais convaincu. Je recommande fortement la version payante pour profiter de tout ce qu'elle offre... vous ne serez pas déçu! Téléchargez-la en confiance et profitez-en!"
        },
        review3: {
          title: "La meilleure",
          text: "J'ai essayé beaucoup d'apps de stats. Linemate est celle à laquelle je reviens toujours. Elle offre beaucoup gratuitement, ajoute des fonctionnalités sans rien retirer, et l'abonnement Plus vaut largement son prix. Le support a répondu en 5 minutes. On sent qu'ils veulent devenir l'app de référence. Fortement recommandé."
        },
        review4: {
          title: "Agréablement surpris",
          text: "Si vous débutez et suivez les props à l'aveugle, les résultats varieront; il faut quand même une stratégie. J'ai téléchargé Linemate après que mes combinés aient raté de peu à plusieurs reprises, et mon premier combiné de 7 props joueur est passé. Pour 10 $/mois (avec une première semaine gratuite), ça vaut facilement le coup. Ce ne sera pas parfait, mais l'app fait la plus grande partie du travail."
        },
        review5: {
          title: "Super app!",
          text: "Aucune app de paris n'est parfaite à 100%, mais celle-ci m'a donné les meilleurs résultats jusqu'ici. Tout repose sur de vraies stats et données. La version gratuite est solide, et l'abonnement est encore meilleur; vous pouvez facilement le rentabiliser avec cette app."
        },
        review6: {
          title: "Une excellente app qui se démarque",
          text: "Excellente app qui se démarque vraiment, abordable et dotée de solides fonctionnalités de recherche. Dans l'ensemble, superbe travail, continuez comme ça."
        },
      },
    },
    summary: {
      title: "Votre profil est prêt",
      subtitle: "Nous avons personnalisé l'app selon vos choix. Créez votre profil pour l'enregistrer et commencer.",
      leagues: "Vos ligues",
      location: "Votre emplacement",
      oddsFormat: "Votre format de cotes",
      operators: "Vos opérateurs",
      noOperators: "Aucun opérateur",
    },
    consent: {
      title: "Restez informé",
      subtitle: "Recevez des mises à jour sur les fonctionnalités, les améliorations et les offres. Vous pouvez vous désabonner en tout temps.",
      emailToggle: "Recevoir des mises à jour et offres exclusives par courriel",
      pushToggle: "Activer les notifications pour des analyses en temps réel",
      confirm: "Confirmer mes choix",
    },
  },
};
